import { Box, List, ListItem, ListItemText, styled } from '@mui/material';
import { Link } from 'react-router-dom';

const ListWrapper = styled(Box)(
  ({ theme }) => `
        .MuiListItem-root {
            display: inline-flex;
            align-items: center;
            width: auto;
            padding-left: ${theme.spacing(2)};
            padding-right: ${theme.spacing(2)};
            &.active,
            &:hover {
                background-color: transparent;
                .MuiListItemText-root {
                    .MuiTypography-root {
                        color: ${theme.colors.primary.main};
                    }
                }
            }
        }
`
);

const LogoWrapper = styled(Box)(
  ({ theme }) => `
        display: flex;
        align-items: center;
        
        img {
            height: 35px;
            width: auto;
            margin-right: ${theme.spacing(1)};
        }
`
);

export const HeaderMenu = () => {
  return (
    <Box display="flex" alignItems="center">
      <ListWrapper>
        <List disablePadding component={Box} display="flex">
          <ListItem
            component={Link}
            to="/home"
            sx={{
              '&.active .MuiListItemText-root .MuiTypography-root': {
                fontWeight: 'bold'
              },
              paddingLeft: 0,
              paddingRight: { xs: 0, sm: 2 },
              textDecoration: 'none',
              '&:hover': {
                opacity: 0.9
              }
            }}
          >
            <LogoWrapper>
              <img src="/logo-transparent.png" alt="Portfoliomatic" />
            </LogoWrapper>
            <ListItemText
              sx={{ display: { xs: 'none', sm: 'block' } }}
              primaryTypographyProps={{ color: 'textPrimary' }}
              primary="Portfoliomatic"
            />
          </ListItem>
        </List>
      </ListWrapper>
    </Box>
  );
};

export default HeaderMenu;
